import React from 'react';
import "./style.css";

const HeaderSkeleton = () => (
    <div className="mb-8">
        <div className="flex justify-between items-center mb-6">
            <div className="animate-pulse w-48 h-10 bg-gray-200 rounded"></div>
            <div className="animate-pulse w-32 h-10 bg-gray-200 rounded"></div>
        </div>
        <div className="grid grid-cols-1 md-grid-cols-4 gap-4">
            {[...Array(4)].map((_, index) => (
                <div key={index} className="animate-pulse p-4 bg-gray-200 rounded-lg">
                    <div className="w-20 h-4 bg-gray-300 rounded mb-2"></div>
                    <div className="w-16 h-6 bg-gray-300 rounded"></div>
                </div>
            ))}
        </div>
    </div>
);

const BatchProfileSkeleton = () => (
    <div className="mb-8">
        <div className="grid grid-cols-1 md-grid-cols-3 gap-6">
            {/* Demographics */}
            <div className="animate-pulse bg-white p-6 rounded-lg shadow-sm">
                <div className="w-32 h-6 bg-gray-200 rounded mb-4"></div>
                <div className="space-y-4">
                    {[...Array(3)].map((_, index) => (
                        <div key={index} className="h-24 bg-gray-200 rounded"></div>
                    ))}
                </div>
            </div>

            {/* Salary Analysis */}
            <div className="animate-pulse bg-white p-6 rounded-lg shadow-sm">
                <div className="w-40 h-6 bg-gray-200 rounded mb-4"></div>
                <div className="h-48 bg-gray-200 rounded mb-4"></div>
                <div className="space-y-2">
                    {[...Array(4)].map((_, index) => (
                        <div key={index} className="h-6 bg-gray-200 rounded"></div>
                    ))}
                </div>
            </div>

            {/* Performance Outliers */}
            <div className="animate-pulse bg-white p-6 rounded-lg shadow-sm">
                <div className="w-36 h-6 bg-gray-200 rounded mb-4"></div>
                <div className="space-y-4">
                    {[...Array(6)].map((_, index) => (
                        <div key={index} className="flex items-center space-x-3">
                            <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
                            <div className="flex-1">
                                <div className="w-24 h-4 bg-gray-200 rounded mb-2"></div>
                                <div className="w-16 h-4 bg-gray-200 rounded"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
);

const CEEPerformanceMetricsSkeleton = () => (
    <div className="animate-pulse mb-8 bg-white p-6 rounded-lg shadow-sm">
        <div className="w-48 h-6 bg-gray-200 rounded mb-6"></div>
        <div className="grid grid-cols-1 md-grid-cols-4 gap-4">
            {[...Array(4)].map((_, index) => (
                <div key={index} className="p-4 bg-gray-200 rounded-lg">
                    <div className="w-20 h-4 bg-gray-300 rounded mb-2"></div>
                    <div className="w-24 h-20 bg-gray-300 rounded mb-2"></div>
                    <div className="w-full h-2 bg-gray-300 rounded"></div>
                </div>
            ))}
        </div>
    </div>
);

// const CoreSkillsAssessmentSkeleton = () => (
//     <div className="mb-8 bg-white p-6 rounded-lg shadow-sm">
//         <div className="w-48 h-6 bg-gray-200 rounded mb-6"></div>
//         <div className="grid grid-cols-1 md-grid-cols-3 gap-6">
//             {[...Array(6)].map((_, index) => (
//                 <div key={index} className="p-4 bg-gray-200 rounded-lg">
//                     <div className="flex items-center mb-3">
//                         <div className="w-10 h-10 bg-gray-300 rounded-full mr-3"></div>
//                         <div className="w-24 h-4 bg-gray-300 rounded"></div>
//                     </div>
//                     <div className="w-full h-2 bg-gray-300 rounded mb-2"></div>
//                     <div className="w-20 h-4 bg-gray-300 rounded"></div>
//                 </div>
//             ))}
//         </div>
//     </div>
// );

const CollegeDashboardSkeleton = () => {
    return (
        <div className="text-gray-800">
            <div className="max-width-7xl p-6">
                <HeaderSkeleton />
                <BatchProfileSkeleton />
                <CEEPerformanceMetricsSkeleton />
                {/* <CoreSkillsAssessmentSkeleton /> */}
            </div>
        </div>
    );
};

export default CollegeDashboardSkeleton;
